//@flow
import { createSelector } from 'reselect';
import _ from 'lodash';

import {
    clientSelector,
    editEntityIdSelector
} from 'common/redux/selectors/queryParamsSelectors';

import { personnelSelector } from 'common/redux/selectors/sessionSelector';

export default class BaseEntitySelectors {
    storeName: string;
    constructor(storeName: string) {
        this.storeName = storeName;
    }

    storeSelector = (state: Object) => {
        return state[this.storeName];
    };

    isEntitiesLoading = createSelector(
        [this.storeSelector, clientSelector],
        (entityState, clientId) => {
            return entityState.getIn(
                ['records', clientId, 'entities', 'status', 'isLoading'],
                false
            );
        }
    );
    isLocationPolling = createSelector(
        [this.storeSelector, clientSelector],
        (entityState, clientId) => {
            return entityState.getIn(
                ['records', clientId, 'entities', 'status', 'isPolling'],
                false
            );
        }
    );

    getEntities = createSelector(
        [this.storeSelector, clientSelector],
        (...args) => this.getEntitiesForClient(...args)
    );

    getEntitiesForClient = (entityState, clientId) => {
        return entityState.getIn(['records', clientId, 'entities', 'records']);
    };

    getEditingEntity = createSelector(
        [this.getEntities, editEntityIdSelector],
        (...args) => this.getEntityFromEntityId(...args)
    );

    getEntityFromEntityId = (entities, entityId) => {
        if (!entityId || !entities) {
            return;
        }
        return _.find(entities.entities, entities => entities.id === entityId);
    };

    getFetchEntitiesError = createSelector(
        [this.storeSelector, clientSelector],
        (entityState, clientId) => {
            return entityState.getIn([
                'records',
                clientId,
                'entities',
                'error'
            ]);
        }
    );

    canPersonnelManageEntities = createSelector(
        personnelSelector,
        personnel => {
            return personnel && personnel.canManageEntities
                ? personnel.canManageEntities
                : false;
        }
    );

    canPersonnelVerifyEntities = createSelector(
        [this.storeSelector, clientSelector],
        (entityState, clientId) => {
            const entityAccess = entityState.getIn([
                'records',
                clientId,
                'entities',
                'entityAccess'
            ]);
            return entityAccess ? entityAccess.verifyAccess : false;
        }
    );
}
